<template>
	<GridLayout
		:sidebar-state="false"
		right-title="PACIENTE"
		:back-action="() => $router.push({ name: 'Patients' })"
	>
		<template #right-content>
			<ToolBar>
				<div
					id="tab-list"
					class="h-full flex-1 justify-center"
				>
					<a
						class="tab-item"
						:class="{
							active: selectedTab === 'schedulings',
						}"
						@click="SelectTab('schedulings')"
						>AGENDAMENTOS
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedTab === 'data',
						}"
						@click="SelectTab('data')"
						>DADOS
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedTab === 'journey',
						}"
						@click="SelectTab('journey')"
						>JORNADA
					</a>
					<a
						class="tab-item"
						:class="{
							active: selectedTab === 'history',
						}"
						@click="SelectTab('history')"
						>PRONTUÁRIO
					</a>
				</div>
			</ToolBar>

			<div
				v-if="patient"
				class="w-full flex flex-col items-center"
			>
				<PatientIdentification
					:patient="patient"
					@on-update-avatar="patient.avatar = $event"
				/>

				<div
					id="main"
					class="w-full flex-1"
				>
					<Schedulings
						v-if="selectedTab === 'schedulings'"
						:patient="patient"
					/>

					<MainContent
						v-if="selectedTab === 'data'"
						id="info"
						class="px-4"
						style="max-height: 52vh"
					>
						<PatientForm
							ref="patient_form"
							class=""
							:patient="patient"
							@next="GetPatient()"
						>
						</PatientForm>
					</MainContent>

					<Journey
						v-if="selectedTab === 'journey'"
						:patient="patient"
					/>

					<History
						v-if="selectedTab === 'history'"
						:patient="patient"
					/>
				</div>
			</div>
		</template>
		<template #right-footer>
			<div class="w-full h-full flex items-center justify-end">
				<button
					class="btn btn-success btn-fixed-size"
					:disabled="selectedTab !== 'data'"
					@click="$refs.patient_form.Continue()"
				>
					SALVAR
				</button>
			</div>
		</template>
	</GridLayout>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	import History from '../patient/components/History'
	import Journey from '../patient/components/Journey'
	import Schedulings from '../patient/components/Schedulings'

	export default {
		name: 'PatientPanel',
		components: {
			History,
			Journey,
			Schedulings,
		},
		props: {
			patient_id: {
				type: [Number, String],
				required: true,
			},
		},
		data() {
			return {
				selectedTab: 'data',
				patient: null,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		watch: {},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			SelectTab(tab) {
				this.selectedTab = tab
			},
			async GetPatient() {
				this.StartLoading()

				return window.api
					.call('post', '/get-patient', {
						account_id: this.requester_selected_id,
						patient_id: this.patient_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.patient = data.patient
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			TogglePatientStatus() {
				this.StartLoading()

				return window.api
					.call('post', '/toggle-patient-status', {
						account_id: this.requester_selected_id,
						patient_id: this.patient_id,
					})
					.then(async ({ data }) => {
						if (data.response) {
							await this.GetPatient()
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
		async beforeMount() {
			await this.GetPatient(this.patient_id)
		},
	}
</script>

<style lang="css" scoped>
	:deep(.new-datatable) {
		height: 30.2rem;
	}
</style>
